/// <amd-module name="Search/Shared/Components/ShowMoreRow" />
export * from "./ShowMoreRow/index";
